import React, { useEffect, useState } from 'react';
import { PolygonSurgeTabProps } from '../surge-tabs/types';
import { toast } from 'react-toastify';
import { Switch, ToastMessage } from '@cokitchen/cokitchen-components';
import { ALL_POLYGONS_ID, STORAGE_KEYS } from 'utils/constants';
import { apiService } from 'utils/api';
import { getGeneralSurgeSnapshot, getPolygonSurge } from 'utils/firebase';
import useDashboardContext from 'contexts/dashboard.context';
import { handleApiError } from 'utils/functions';

const DeliverySettingsApplyNow: React.FC<PolygonSurgeTabProps> = ({
  confirm,
  setLoading,
  onClose,
  cokitchen_polygon_id
}) => {
  const [delivery, setDelivery] = useState(false);
  const [defaultDelivery, setDefaultDelivery] = useState(false);
  const [pickup, setPickup] = useState(false);
  const { activeCokitchen } = useDashboardContext();
  const [defaultPickup, setDefaultPickup] = useState(false);
  const [available, setAvailable] = useState(false);
  const [defaultAvailable, setDefaultAvailable] = useState(false);
  const cokitchenId = localStorage.getItem(STORAGE_KEYS.COKITCHEN) ?? '';
  const COKITCHEN_ABUJA = '36085195-7ebe-4cb9-acff-fb02c336bdb5';

  const updateDelivery = !(defaultDelivery === delivery && defaultPickup === pickup);
  const updateAvailability = !(defaultAvailable === available);

  const updateDeliveryOptions = async () => {
    setLoading(true);
    try {
      const data = {
        delivery,
        pickup
      };
      const riderAvailabilityData = {
        toggle: available,
        cokitchen_id: cokitchenId,
        priority_delivery_partner: 'shipbubble'
      };
      if (cokitchen_polygon_id === ALL_POLYGONS_ID) {
        if (updateDelivery) {
          await apiService.post('logistics/delivery-settings/general/instant', {
            data,
            baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
          });
        }
        if (updateAvailability) {
          await apiService.post('logistics/rider-availability', {
            data: riderAvailabilityData,
            baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
          });
        }
      } else {
        if (updateDelivery) {
          await apiService.post('logistics/delivery-settings/polygon/instant', {
            data: {
              ...data,
              cokitchen_polygon_id
            },
            baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
          });
        }
        if (updateAvailability) {
          await apiService.post('logistics/rider-availability', {
            data: { ...riderAvailabilityData, polygon_id: cokitchen_polygon_id },
            baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
          });
        }
      }
      toast(<ToastMessage type='success' message='Updated successfully' />);
      onClose();
    } catch (error) {
      onClose();
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (confirm === 'Apply Now') {
      (async () => {
        await updateDeliveryOptions();
      })();
    }
  }, [confirm]);

  const setDeliveryPickup = (doc: any) => {
    const { delivery: newDelivery, pickup: newPickup, riders_available } = doc;
    setDelivery(newDelivery ?? false);
    setDefaultDelivery(newDelivery ?? false);
    setPickup(newPickup ?? false);
    setDefaultPickup(newPickup ?? false);
    setAvailable(riders_available ?? false);
    setDefaultAvailable(riders_available ?? false);
  };

  useEffect(() => {
    if (cokitchen_polygon_id) {
      if (cokitchen_polygon_id === 'ALL')
        getGeneralSurgeSnapshot(activeCokitchen.id, setDeliveryPickup);
      else getPolygonSurge(cokitchen_polygon_id, setDeliveryPickup);
    }
  }, [cokitchen_polygon_id]);

  return (
    <>
      <div className='flex gap-x-4 mt-6'>
        <Switch label='Delivery' active={delivery} onChange={() => setDelivery(!delivery)} />
        <Switch label='Pickup' active={pickup} onChange={() => setPickup(!pickup)} />
      </div>
      {cokitchenId === COKITCHEN_ABUJA ? null : (
        <div className='flex items-center gap-1.5 mt-4 pt-4 border-t border-gray-border'>
          <span className='font-medium'>Rider status:</span>
          <Switch active={available} onChange={() => setAvailable(!available)} />
          <span>Available</span>
        </div>
      )}
    </>
  );
};

export default DeliverySettingsApplyNow;
